import React from 'react';

// Функція для форматування дати (лише рік, місяць і день)
const formatDate = (isoString) => {
    return new Date(isoString).toLocaleDateString('uk-UA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

export default function TicketDetails({ ticket }) {
    if (!ticket) return <p>Квиток не знайдено.</p>;

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>{ticket.product_name}</h2>

            <p>
                <strong>Ціна:</strong>{' '}
                {ticket.initial_price === "0.00" ? "Безкоштовно" : `${ticket.initial_price} грн`}
            </p>
            <p>
                <strong>Загальна кількість поїздок:</strong> {ticket.initial_units}
            </p>
            <p>
                <strong>Використано:</strong> {ticket.used_units}
            </p>
            <p>
                <strong>Залишилось:</strong> {ticket.initial_units - ticket.used_units}
            </p>
            <p>
                <strong>Активний з:</strong> {formatDate(ticket.active_from)}
            </p>
            <p>
                <strong>Дійсний до:</strong>{' '}
                {(ticket.active_to === 0 || ticket.active_to === null) ? "Безстрокова" : formatDate(ticket.active_to)}
            </p>

            <div>
                <strong>Послуги:</strong>
                <ul>
                    {ticket.services.map((service, index) => (
                        <li key={index}>{service}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

const styles = {
    container: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '15px',
        maxWidth: '400px',
        backgroundColor: '#f9f9f9',
    },
    title: {
        fontSize: '18px',
        marginBottom: '10px',
    },
};